(function ($) {
  Drupal.behaviors.beauty_advisor_reviews_v1 = {
    attach: function (context, settings) {
      var letsTalkButton = $('.lets-talk-button', context);
      var isDesktop = $('.device-pc').length;

      letsTalkButton.on('click', function (e) {
        e.preventDefault();
        if (isDesktop) {
          lpMTagConfig.delegate.prechatWindow();
        } else {
          document.location = '/customer_service/livechat/prechat.tmpl?SKILL=ELMobile';
        }
      });

      var starsContainer = $('.beauty-advisor-stars-container', context);

      starsContainer.click(function () {
        var offset;

        if (isDesktop) {
          offset = 100;
        } else {
          offset = 50;
        }
        var reviewsTop = $('.spp-product__reviews').offset().top;

        window.scrollTo(0, reviewsTop - offset);
      });
    }
  };
})(jQuery);
